<template>
  <div class="container-list" v-loading="loading">
    <!-- <ul class="tab-wrap" style="border:none" >
      <li
        :class="`tab-btn ${nowIndex == index && 'active'}`"
        @click="changeTab(index,tab)"
        v-for="(tab, index) in tabList"
      >
        {{tab.name }}
      </li>
    </ul> -->
    <div class="common-page common-head">
      <div class="common-page common-head-title">
        <i class="icon-tr--detailed" style="padding-right: 5px"></i>
        巡查项管理
      </div>
    </div>
    <div class="flex containerPage">
      <div class="flex1">
        <div class="common-page common-tool-bar" style="text-align: end;">
          <div v-if="tabList[nowIndex].id == 0">
            <div class="btn" @click="$router.push('/safe/safe-add')"><i class="icon-tr-newly-added"></i>新增</div>
            <!-- <div class="btn" @click="showDia = true"><i class="icon-tr-search"></i>查询</div> -->
          </div>
          <div v-if="tabList[nowIndex].id == 1">
            <div class="btn" @click="$router.push('/safe/safe-wwadd')"><i class="icon-tr-newly-added"></i>新增</div>
            <!-- <div class="btn" @click="showDia = true"><i class="icon-tr-search"></i>查询</div> -->
          </div>
        </div>
        <div v-if="tabList[nowIndex].id == 0">
          <div class="common-page common-list">
            <el-table :data="list" class="">
              <el-table-column prop="checklist" label="巡检检查项" align="center"> </el-table-column>
              <el-table-column prop="remarks" label="备注" align="center"> </el-table-column>
              <el-table-column prop="ordernumber" align="center" label="本机序列号"> </el-table-column>
              <el-table-column prop="m_createtime" align="center" label="创建时间"> </el-table-column>
              <el-table-column align="center" label="操作">
                <template slot-scope="scope">
                  <router-link
                    :to="{
                      path: '/safe/safe-add',
                      query: { m_uuid: scope.row.m_uuid },
                    }"
                  >
                    <el-button size="mini" type="warning">编辑</el-button>
                  </router-link>
                  <router-link
                    :to="{
                      path: '/safe/safe-add',
                      query: {
                        m_uuid: scope.row.m_uuid,
                        checklist: scope.row.checklist,
                      },
                    }"
                  >
                    <el-button size="mini" type="primary"> 添加 </el-button>
                  </router-link>
                  <el-popconfirm title="确定禁用此记录吗？" class="cursor" @confirm="changeStatus(scope.row.m_uuid, 0)" @onConfirm="changeStatus(scope.row.m_uuid, 0)">
                    <a slot="reference" class="red">
                      <el-button size="mini" type="danger"> 删除 </el-button>
                    </a>
                  </el-popconfirm>
                </template>
              </el-table-column>

              <el-table-column type="expand">
                <template slot-scope="props">
                  <!-- <div>{{props.row.childChecl}}</div> -->
                  <el-table :data="props.row.childChecl" label-position="left" inline>
                    <el-table-column prop="checklist" label="检查项" align="center"> </el-table-column>
                    <el-table-column prop="ordernumber" label="本级序列号" align="center"> </el-table-column>
                    <el-table-column prop="m_createtime" label="创建时间" align="center"> </el-table-column>
                    <el-table-column prop="props" label="操作" align="center">
                      <template slot-scope="scope">
                        <router-link
                          :to="{
                            path: '/safe/safe-add',
                            query: { m_uuid: scope.row.m_uuid },
                          }"
                        >
                          编辑
                        </router-link>

                        <el-popconfirm title="确定禁用此记录吗？" class="cursor" @onConfirm="changeStatus(scope.row.m_uuid, 0)">
                          <a slot="reference" class="red"> 删除 </a>
                        </el-popconfirm>
                      </template>
                    </el-table-column>
                  </el-table>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!-- <el-tree
             :data="data"
             :props="defaultProps"
              accordion
            @node-click="handleNodeClick">
</el-tree> -->
          <el-pagination background layout="prev, pager, next" @current-change="pageChange" :page-size="10" :total="total"> </el-pagination>
        </div>
        <div v-if="tabList[nowIndex].id == 1">
          <div class="common-page common-list">
            <el-table :data="list1" class="mt10">
              <el-table-column prop="checklist" label="巡检检查项" align="center"> </el-table-column>
              <el-table-column prop="remarks" label="备注" align="center"> </el-table-column>
              <el-table-column prop="ordernumber" align="center" label="本机序列号"> </el-table-column>
              <el-table-column prop="m_createtime" align="center" label="创建时间"> </el-table-column>
              <el-table-column align="center" label="操作">
                <template slot-scope="scope">
                  <router-link
                    :to="{
                      path: '/safe/safe-wwadd',
                      query: { m_uuid: scope.row.mid },
                    }"
                  >
                    <!-- 编辑 -->
                    <el-button size="mini" type="warning">编辑</el-button>
                  </router-link>
                  <router-link
                    :to="{
                      path: '/safe/safe-wwadd',
                      query: {
                        m_uuid: scope.row.mid,
                        checklist: scope.row.checklist,
                      },
                    }"
                  >
                    <el-button size="mini" type="primary">新增</el-button>
                  </router-link>
                  <el-popconfirm title="确定禁用此记录吗？" class="cursor" @confirm="changeStatus(scope.row.mid, 0)" @onConfirm="changeStatus(scope.row.mid, 0)">
                    <a slot="reference" class="red">
                      <el-button size="mini" type="danger">删除</el-button>
                    </a>
                  </el-popconfirm>
                </template>
              </el-table-column>
              <el-table-column type="expand">
                <template slot-scope="props">
                  <!-- <div>{{props.row.childChecl}}</div> -->
                  <el-table :data="props.row.childTreeList" label-position="left" inline>
                    <el-table-column prop="checklist" label="检查项" align="center"> </el-table-column>
                    <el-table-column prop="ordernumber" label="本级序列号" align="center"> </el-table-column>
                    <el-table-column prop="m_createtime" label="创建时间" align="center"> </el-table-column>
                    <el-table-column prop="props" label="操作" align="center">
                      <template slot-scope="scope">
                        <router-link
                          :to="{
                            path: '/safe/safe-wwadd',
                            query: { m_uuid: scope.row.mid },
                          }"
                        >
                          编辑
                        </router-link>
                        <el-popconfirm title="确定禁用此记录吗？" class="cursor" @onConfirm="changeStatus(scope.row.mid, 0)">
                          <a slot="reference" class="red"> 删除 </a>
                        </el-popconfirm>
                      </template>
                    </el-table-column>
                  </el-table>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!-- <el-tree
             :data="data"
             :props="defaultProps"
              accordion
            @node-click="handleNodeClick">
</el-tree> -->
          <el-pagination background layout="prev, pager, next" @current-change="pageChange" :page-size="10" :total="total"> </el-pagination>
        </div>
      </div>
    </div>
    <el-dialog title="查询" :visible.sync="showDia" :close-on-click-modal="false">
      <fm-generate-form :data="searchForm" :remote="remoteFuncs" :value="editData" ref="searchForm"> </fm-generate-form>
      <div class="center">
        <el-button type="primary" @click="searchSubmit" size="small">确定</el-button>
        <el-button @click="cancle" size="small">重置</el-button>
      </div>
    </el-dialog>
    <el-backtop target=".common-body-style"></el-backtop>
  </div>
</template>

<script>
import { getSafeList } from '../../api/safety';
import unitList from '@/components/unitList';
export default {
  data() {
    return {
      list: [],
      list1: [],
      tabList: this.$store.state.user.userInfo.isWenwu ? [{ name: '文物巡查', id: 1 }] : [{ name: '消防巡查', id: 0 }],
      nowIndex: 0,

      loading: false,
      params: { page: 1 },
      wwParams: {
        page: 1,
      },
      total: 0,
      showDia: false,
      searchForm: this.$getForm('manageSearch'),
      editData: {},
      remoteFuncs: {},
    };
  },
  created() {
    this.getDatas();
  },
  components: {
    unitList,
  },
  watch: {
    // nowIndex(){
    //     this.getDatas()
    // }
  },
  methods: {
    cancle() {
      this.resetSearch();
      this.getDatas();
    },
    getDatas() {
      if (this.tabList[this.nowIndex].id == 0) {
        this.getList();
      } else {
        this.getWWlist();
      }
    },
    changeTab(index, it) {
      this.nowIndex = index;
      this.getDatas();
    },
    getWWlist() {
      this.loading = true;
      this.$post('/inspectionWenWu/findtree')
        .then((res) => {
          // console.log(res.data)
          this.total = res.data.count;
          this.list1 = res.data.list;
          this.loading = false;
        })
        .catch((err) => {});
    },
    getCheckList(data) {
      this.loading = true;
      this.$post('/checklist/searchcheck', data).then((res) => {
        this.total = res.data.count;
        this.list = res.data.list;
        this.loading = false;
      });
    },
    changeStatus(m_uuid, status) {
      let url = '/checklist/deletecheckmain';
      if (this.tabList[this.nowIndex].id == 1) url = '/inspectionWenWu/deletecheckmain';
      this.$post(url, { m_uuid }).then((res) => {
        // this.$message.success('删除成功');
        this.$message({
									message: "删除成功",
									type: 'success',
									duration: 700,
								});
        this.getDatas();
      });
    },
    getList() {
      this.loading = true;
      getSafeList()
        .then((res) => {
          // console.log(res.data)
          this.total = res.data.count;
          this.list = res.data.list;
          this.loading = false;
        })
        .catch((err) => {});
    },
    pageChange(val) {
      this.params.page = val;
      this.getDatas();
    },
    searchSubmit() {
      this.$refs.searchForm
        .getData()
        .then((data) => {
          log(data);
          this.params = { ...this.params, ...data };
          this.params.page = 1;

          this.getCheckList(data);
          this.showDia = false;
        })
        .catch((e) => {});
    },
    getUnit() {},
    resetSearch() {
      this.$refs.searchForm.reset();
      this.params = { page: 1, limit: 10, ...this.$refs.searchForm.models };
      this.getDatas();
    },
  },
};
</script>

<style scoped>
.btn {
  margin-left: 10px;
}
</style>
